export default __webpack_public_path__ + "static/media/bars.9a3b1eee.svg";